import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  CardOverline, CardDate, CardBodyText,
  CardTextContainer, CardContainer, FullWidthImageContainer,
} from '../Card';
import Headline5 from '../Typography/Heading/Headline5';
import Labels from '../Card/Labels';

const StyledHeadline5 = styled(Headline5)`
  && {
    margin: 0 0 8px;
    ${(properties) => properties.icon && `
      display: flex;
      justify-content: space-between;
    `
}
  }
`;

const MediumCard = ({
  title,
  category,
  createdAt,
  image,
  description,
  labels,
  children,
  icon,
  featured,
  withPageMargins,
  logoLetterbox,
}) => (
  <CardContainer className="card-container">
    {image && (
    <FullWidthImageContainer
      featured={featured}
      withPageMargins={withPageMargins}
      logoLetterbox={logoLetterbox}
    >
      {image}
    </FullWidthImageContainer>
    )}
    <CardTextContainer>
      { category && (
        <CardOverline
          className="highlight-color"
        >
          {category}
          <Labels labels={labels} featured={featured} />
        </CardOverline>
      )}
      <StyledHeadline5
        tag="h2"
        icon={icon}
      >
        {title}
        {icon}
      </StyledHeadline5>
      {
        description && (
          <CardBodyText>
            {description}
          </CardBodyText>
        )
      }
      {createdAt && <CardDate>{createdAt}</CardDate>}
      { children }
    </CardTextContainer>
  </CardContainer>
);

MediumCard.defaultProps = {
  title: undefined,
  description: undefined,
  image: undefined,
  category: undefined,
  createdAt: undefined,
  labels: [],
  children: undefined,
  icon: undefined,
  featured: false,
  withPageMargins: false,
  logoLetterbox: false,
};

MediumCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  image: PropTypes.node,
  category: PropTypes.string,
  createdAt: PropTypes.node,
  icon: PropTypes.node,
  labels: PropTypes.arrayOf(PropTypes.string),
  featured: PropTypes.bool,
  withPageMargins: PropTypes.bool,
  logoLetterbox: PropTypes.bool,
};

export default MediumCard;
